"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Device extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Pushes the app to the active users mobile phone(s).
     * @param app_id
     * @returns
     */
    install(app_id) {
        const requestObj = {
            method: 'post',
            url: `/mobile/install_app/${app_id}`,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Device;
